import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Horizon was called "Procurement Calendar" until the 2026-09 rename. Saved-view
 * deep links live in already-sent notification emails and in user bookmarks, so
 * the old path has to keep resolving. Search params carry the view id and are
 * forwarded untouched.
 */
export const Route = createFileRoute(
  "/_authed/$companySlug/procurement-calendar/",
)({
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/$companySlug/horizon",
      params,
      search,
      replace: true,
    });
  },
});
